module.exports = __webpack_public_path__ + "img/glimpse-fze.c0d425e2.png";